import { render, staticRenderFns } from "./ClientVersion.vue?vue&type=template&id=18a72ad6&scoped=true&"
import script from "./ClientVersion.vue?vue&type=script&lang=js&"
export * from "./ClientVersion.vue?vue&type=script&lang=js&"
import style0 from "./ClientVersion.vue?vue&type=style&index=0&id=18a72ad6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a72ad6",
  null
  
)

export default component.exports